export function target() {
  return ['Header', 'PromoHeader'].includes(this.module) && !this.data.banners;
}

export function migrate() {
  if (this.module === 'Header') {
    this.module = 'BannerWithMenu';
    this.data.useMaxHeight = true;
  }

  const {
    background,
    backgroundColor,
    image,
    applyImageFilter,
    backgroundColorMenu,
    menuTextColor,
  } = this.data;

  delete this.data.background;
  delete this.data.backgroundColor;
  delete this.data.image;
  delete this.data.applyImageFilter;
  delete this.data.backgroundColorMenu;
  delete this.data.menuTextColor;

  this.data.backgroundColor = backgroundColorMenu;
  this.data.textColor = menuTextColor;
  this.data.banners = []; // the target validation ensures it won't overwrite

  if (this.data.title) {
    this.data.useFixedText = true;

    if (
      (background === 'backgroundImage' && image) ||
      (background === 'backgroundColor' && backgroundColor)
    ) {
      this.data.banners = [
        {
          background,
          backgroundColor,
          image,
          applyImageFilter,
        },
      ];
    }
  } else if (
    this.data.opacity === 0 &&
    background === 'backgroundColor' &&
    backgroundColor
  ) {
    this.data.backgroundColor = backgroundColor;
    this.data.opacity = 1;
  }
}
